module.exports = __webpack_public_path__ + "img/East German.f426b095.svg";